import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'calc(15%)',
    margin: '5px 20px 10px 0px',
    [theme.breakpoints.between('834px', '1194px')]: {
      margin: '5px 10px 10px 0px',
    },
    '&.selected': {
      [theme.breakpoints.up('sm')]: {
        backgroundColor: '#f5f0f9',
        border: `2px solid ${theme.palette.secondary.main}`,
      },
    },
    '&.readonly': {
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('md')]: {
      flexBasis: 'calc(50% - 20px)',
      margin: '5px 10px 10px 0px',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: 120,
      minHeight: 120,
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      border: '2px solid #D9D9D9',
      textAlign: 'center',
      transition: 'border-color 0.3s',
    },
    [theme.breakpoints.down('xs')]: {
      margin: 'unset',
    },
    '&:not(.readonly):hover': {
      [theme.breakpoints.up('sm')]: {
        backgroundColor: '#f5f0f9',
      },
      borderColor: theme.palette.secondary.main,
    },
    '&:last-child': {
      [theme.breakpoints.up('lg')]: {
      marginRight: 'unset',
      }
    },
    '&:last-child:nth-child(odd)': {
      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
      },
    },
  },
  value: {
    color: '#191919',
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      borderRadius: 4,
      textAlign: 'center',
      border: `2px solid ${theme.palette.secondary.main}`,
      backgroundColor: '#fafafa',
      transition: 'border-color 0.3s',
      padding: 10,
      margin: 5,
      fontSize: theme.typography.fontSizeMedium,
      '&.selected': {
          backgroundColor: '#f5f0f9',
          border: `2px solid ${theme.palette.secondary.main}`,
      },
    },
  },
  icon: {
    position: 'absolute',
    top: '-2%',
    right: '-2%',
    color: theme.palette.secondary.main,
    fontSize: 24,
    borderRadius: '50%',
    [theme.breakpoints.down('xs')]: {
      top: '30%',
      right: '2%',
    },
  },
  inputContainer: {
    alignItems: 'center',
    width: '90%',
    borderColor: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      margin: '3%',
      width: '90%',
      backgroundColor: '#fafafa',
      '&.selected': {
        backgroundColor: '#f5f0f9',
      },
    },
  },
  input: {
    '&.selected': {
      border: `2px solid ${theme.palette.secondary.main}`,
    },
    backgroundColor: '#fafafa',
    textAlign: 'center',
    border: '2px solid #e7e7e2',
    width: '100%',
    padding: '10px',
    borderRadius: 6,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '11px',
      paddingBottom: '11px',
      borderColor: 'inherit',
      backgroundColor: 'inherit',
      borderRadius: 4,
      height: '42px',
    },
    '&:focus-visible': {
      outlineColor: theme.palette.secondary.main,
    },
    '&:placeholder': {
      textAlign: 'center',
      color: '#9a9a96', // Placeholder text color
      opacity: 1, // Ensures the placeholder is fully visible
    },
    '&:focus:placeholder': {
      color: 'transparent', // Placeholder text becomes transparent on focus
    },
  },
}));

export const AmountTypography = styled(Typography)(({ theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  [theme.breakpoints.down('sm')]: {
    fontSize: 12,
    fontWeight: 700,
  },
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  '&&': {
    color: '#191919',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 12,
    fontWeight: 400,
    '&&': {
      color: '#404040',
    },
  },
}));
